/**
 * Minimal Redux Store for Streaks/FAQ MFE
 * 
 * Creates a Redux store that matches the structure expected by streaks-ui components.
 * This is needed because FAQ and Streaks components use Redux hooks (useAppDispatch).
 * 
 * @module services/mfe/streaksStore
 */

import { configureStore } from '@reduxjs/toolkit';

// Minimal reducers that match streaks-ui structure
const userReducer = (state: any = { preferenceProfile: null }) => {
  // Handle basic actions if needed
  return state;
};

const streaksReducer = (state: any = {}) => {
  // Handle basic actions if needed
  return state;
};

// Create store matching streaks-ui structure
export const createStreaksStore = () => {
  const store = configureStore({
    reducer: {
      user: userReducer,
      streaks: streaksReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false, // Allow non-serializable values
      }),
  });

  return store;
};

